import { HOTKEYS, HOTKEY_CATEGORY, MENU_ITEMS } from 'enums'

export const newProjectId = 'new'
export const newProjectName = 'Untitled'
export const videoUrlTimeFragmentParam = '#t'
export const defaultPlayerVolume = 1
export const MAX_ASSET_VOLUME = 4

// HISTORY ACTIONS (UNDO-REDO)

export const colorPickerChangingSettings = [ 'outlineColor', 'color', 'shadowColor' ]
export const continiousChangingSettings = [ 'opacity',
  'outlineWidth',
  'text',
  'background',
  'shadowBlur',
  'similarity',
  'chromaKeyColor',
  'smoothness',
  'spillReduction',
  'font',
  'fontSize',
  'textTransform',
  'fontStyle',
  'align',
  'position',
  'disableOutline',
  'disableShadow',
  'shadowOffset',
]

export const continiousChangingAssetParams = [ 'volume' ]
export const continiousChangingSettingsDebounceMs = 500
export const localStorageLastCapturedLiveStreamURL = 'lastCapturedLiveStreamURL'
export const localStorageActiosHistoryProjectId = 'actiosHistoryProjectId'
export const localStoragePendingHistoryActions = 'pendingHistoryActions'
export const localStoragePendingActionEvents = 'pendingActionEvents'
export const LOCAL_STORAGE_SOURCE_FILES_PARAMS = 'sourceFilesParams'
export const STORAGE_SOURCE_FILES_NAV_HISTORY = 'sourceFilesHistory'
export const STORAGE_SOURCE_FILES_NAV_HISTORY_INDEX = 'sourceFilesHistoryIndex'
export const LOCAL_STORAGE_PROJECT_IMPORT_CREATE_FOLDER = 'projectImportCreateFolder'

export const MAX_NAVIGATION_HISTORY_COUNT = 100
export const onlineTestCooldownMs = 5000
export const nearTimeBufferingDiapasonMs = 10_000
export const nearTimeBufferingDiapasonS = nearTimeBufferingDiapasonMs / 1000

export const KEY_Z = 'KeyZ'
export const KEY_Y = 'KeyY'
export const KEY_SPACE = 'Space'

export const DUPLICATED_PROJECT_NAME_POSTFIX = ' copy'

export const DRAGGING_HOVER_ACTIVITY_OFFSET = 10

export const DEFAULT_IMAGE_DURATION = 100_000_000

export const DEFAULT_FOLDER_NAME = 'Untitled'

export const MIN_TIMELINE_ITEM_DURATION = 30000
export const MIN_TIMELINE_ITEM_DURATION_PX = 10

export const MIN_TRANSITION_DURATION = 2500000
export const MAX_TRANSITION_DURATION = 100000000

export const restoringRecord = 'pendingRecord'
export const restoringRecordProjectId = 'pendingRecordProjectId'

export const LAYER_HEIGHT = 64
export const LAYER_BORDER = 4
export const LAYER_HEIGHT_WITH_BORDER = LAYER_HEIGHT + LAYER_BORDER // in pixels layer height + border
export const LAYER_ASSET_HEIGHT = 60
export const LAYER_CONTROL_WIDTH = 54

export const IMAGE_OVERLAY_MAX_SIZE_DEFAULT = 20_000_000


// CHROMA KEY
export const CHROMA_DEFAULT_KEY_COLOR = { r: 0, g: 255, b: 0, a: 1 }
export const CHROMA_DEFAULT_SIMILARITY = 400
export const CHROMA_DEFAULT_SMOOTHNESS = 80
export const CHROMA_DEFAULT_SPILL_REDUCTION = 100
export const CHROMA_DEFAULT_OPACITY = 100
export const CHROMA_MAX_OPACITY = 100

export const MAIN_BLOCK_HEIGHT = 'calc(100% - 52px)'
export const LEFT_MENU_WIDTH = 80
export const MEDIA_BLOCK_MIN_WIDTH = 214
export const MEDIA_BLOCK_MIN_WIDTH_OPTION = 624
export const MEDIA_BLOCK_WIDTH_FOR_FIX_AUDIO_ITEM = 497
export const MEDIA_RECORDING_BLOCK_MIN_WIDTH = 356
export const PREVIEW_CONTAINER_MIN_HEIGHT = 240
export const PREVIEW_MIN_WIDTH = 385
export const PREVIEW_I_O_POINTS_TRIM_HEIGHT = 18
export const SPLIT_PREVIEW_DEFAULT_WIDTH = '50%'
export const TIMELINE_LAYERS_DEFAULT_HEIGHT = 318
export const TIMELINE_MIN_WIDTH = 778
export const TIMELINE_MIN_WIDTH_WITHOUT_RESIZER = 766

export const PREVIEW_SUMMARY_HEIGHT_INDENT = 9
export const PREVIEW_SUMMARY_EXTRA_HEIGHT_INDENT = 7
export const PREVIEW_CANVAS_ADDITIONAL_FREE_SPACE = 25
export const PREVIEW_SUMMARY_WIDTH_INDENT = 18

export const MAX_IMAGE_SIDE_SIZE = 10_000
export const MIN_IMAGE_SIDE_SIZE = 13

export const DEFAULT_IMAGE_WIDTH = 250
export const DEFAULT_IMAGE_HEIGHT = 150

export const MAX_LOGO_SIZE_BYTES = 2_000_000
export const MAX_LOGO_SIZE_PX = 512

export const MIN_ZOOM_VALUE = 1 // Math.log(2.718281828459045) === Math.exp(12.5)
export const MAX_ZOOM_VALUE = 9.8 // Math.log(268337.2865208745) === Math.exp(12.5)
export const STEP_ZOOM_VALUE = 0.1


export const DEFAULT_TEXT_WIDTH = 1880
export const DEFAULT_TEXT_HEIGHT = 24

// MAX element width for Chrome/Edge (Blink): ~33,554,432 pixels
// MAX element width for Firefox (Gecko): ~17,179,869 pixels
export const MAX_SAFE_ELEMENT_WIDTH = 17_100_000
export const VAL_30_MINUTES_AS_100NS_UNIT_SEC = 18_000_000_000

export const MEDIA_ELEMENTS_SIZE = {
  [MENU_ITEMS.AUDIO]: { width: 199, height: 86 },
  [MENU_ITEMS.DESIGN]: { width: 199, height: 150 },
  [MENU_ITEMS.FILTERS]: { width: 199, height: 150 },
  [MENU_ITEMS.IMAGES]: { width: 199, height: 150 },
  [MENU_ITEMS.MEDIA]: { width: 199, height: 150 },
  [MENU_ITEMS.PROJECT_MEDIA]: { width: 199, height: 150 },
  [MENU_ITEMS.TEXT]: { width: 199, height: 150 },
  [MENU_ITEMS.TRANSITIONS]: { width: 199, height: 150 },
  [MENU_ITEMS.VIDEOS]: { width: 199, height: 150 },
}

export const CATEGORIZED_HOTKEYS = {
  [HOTKEYS.UNDO]: HOTKEY_CATEGORY.Timeline,
  [HOTKEYS.REDO]: HOTKEY_CATEGORY.Timeline,
  [HOTKEYS.ZOOM_IN]: HOTKEY_CATEGORY.Timeline,
  [HOTKEYS.ZOOM_OUT]: HOTKEY_CATEGORY.Timeline,
  [HOTKEYS.PREV_FRAME]: HOTKEY_CATEGORY.Preview,
  [HOTKEYS.NEXT_FRAME]: HOTKEY_CATEGORY.Preview,
  [HOTKEYS.ADD_TO_TIMELINE]: HOTKEY_CATEGORY.Timeline,
  [HOTKEYS.INCREASE_CLIP_VOLUME]: HOTKEY_CATEGORY.Tools,
  [HOTKEYS.DECREASE_CLIP_VOLUME]: HOTKEY_CATEGORY.Tools,
  [HOTKEYS.CUT_CLIPS]: HOTKEY_CATEGORY.Timeline,
  [HOTKEYS.RIPPLE_DELETE]: HOTKEY_CATEGORY.Timeline,
  [HOTKEYS.RIPPLE_TRIM_PREV]: HOTKEY_CATEGORY.Timeline,
  [HOTKEYS.RIPPLE_TRIM_NEXT]: HOTKEY_CATEGORY.Timeline,
  [HOTKEYS.SELECT_CLIPS_AT_CURRENT_POSITION]: HOTKEY_CATEGORY.Timeline,
  [HOTKEYS.DELETE]: HOTKEY_CATEGORY.Timeline,
  [HOTKEYS.PLAY_PAUSE]: HOTKEY_CATEGORY.Preview,
  [HOTKEYS.COPY]: HOTKEY_CATEGORY.Timeline,
  [HOTKEYS.PASTE]: HOTKEY_CATEGORY.Timeline,
  [HOTKEYS.PLAY]: HOTKEY_CATEGORY.Preview,
  [HOTKEYS.PAUSE]: HOTKEY_CATEGORY.Preview,
  [HOTKEYS.CLIP_SETTINGS]: HOTKEY_CATEGORY.Timeline,
  [HOTKEYS.MARK_IN]: HOTKEY_CATEGORY.Preview,
  [HOTKEYS.MARK_OUT]: HOTKEY_CATEGORY.Preview,
  [HOTKEYS.CLEAR_IN_OUT_MARK_POINTS]: HOTKEY_CATEGORY.Preview,
  [HOTKEYS.PLAY_TIMELINE_SEGMENT]: HOTKEY_CATEGORY.Preview,
  [HOTKEYS.SEEK_TO_IN_POINT]: HOTKEY_CATEGORY.Preview,
  [HOTKEYS.SEEK_TO_OUT_POINT]: HOTKEY_CATEGORY.Preview,
  [HOTKEYS.NEXT_EDITING_POINT]: HOTKEY_CATEGORY.Timeline,
  [HOTKEYS.PREV_EDITING_POINT]: HOTKEY_CATEGORY.Timeline,
  [HOTKEYS.TOGGLE_MY_MEDIA_VISIBLE]: HOTKEY_CATEGORY.Tools,
  [HOTKEYS.TOGGLE_SETTINGS_VISIBLE]: HOTKEY_CATEGORY.Tools,
}

export const DEFAULT_PROFILE_ID = 'default'
export const DEFAULT_PROFILE_NAME = 'Default'
export const DEFAULT_PROJECT_OUTPUT_NAME = 'output'

export const EMPTY_STRING = ''

export const START_PAGE = {
  DEFAULT: 'default',
  PROJECTS: 'projects',
} as const

export const STORAGE_CONST = {
  DEFAULT_TRANSITION_DURATION: 'DEFAULT_TRANSITION_DURATION',
} as const

export const VIRTUAL_SCROLL_CONTAINER_CLASS = 'virtual-assets-scroll-container'

export const FPS = {
  5994: { fpsNum: 60000, fpsDenum: 1001 },
  2997: { fpsNum: 30000, fpsDenum: 1001 },
}

export const REWIND_SOURCES = {
  CONTEXT: 'context',
  MANUAL: 'manual',
  SAGA: 'saga',
  HOTKEY: 'hotkey',
  DEFAULT: 'default',
}

export const COLOR_PRIMARIES = {
  BT709: 'BT.709',
}


// Removed from the timeline assets when saving the project and restored when loading the project
export const ASSET_RESTORE_PROPERTIES = [ 'mountType', 'folder', 'taskId',
  'videoEncoderParams', 'videoEncoderParsedParams',
  'url', 'errorType', 'fileType', 'filetype', 'startTimeCodeFrames',
  'dfFlag', 'colorPrimaries', 'thumbnail', 'mediaDeleted', 'errorMessage' ]

export const EXCLUDE_DROP_MEDIA_FIELD_PROFILE = [ 'vrspot' ]
